import request from '@/utils/request'

// 0201康熙字典查找
export function queryKangxiDic (data) {
  return request({
    url: '/test/kangxi',
    method: 'post',
    data
  })
}

export function queryMeihua (data) {
  return request({
    url: '/test/meihua',
    method: 'post',
    data
  })
}

// 0205 查询卦
export function queryForecast (data) {
  return request({
    url: '/test/diagrams',
    method: 'post',
    data
  })
}

// 0202姓名凶吉
export function queryName (data) {
  return request({
    url: '/test/name',
    method: 'post',
    data
  })
}

// 0204获取测算分享url
export function shareTest (data) {
  return request({
    url: '/test/share',
    method: 'post',
    data
  })
}

// 0209 公历查询八字
export function testSiZhu (data) {
  return request({
    url: '/test/sizhu',
    method: 'post',
    data
  })
}
